import { gql, useLazyQuery } from "@apollo/client";

export const REPORT_DATA_QUERY = gql`
  query GetReportData(
    $reportName: String
    $reportVariables: Map_String_ObjectScalar
  ) {
    report(reportId: $reportName, reportParameters: $reportVariables)
  }
`;

export interface ReportDataQuery {
  report: string;
}

export const useGetReportData = () => {
  const [performQuery] = useLazyQuery<ReportDataQuery>(REPORT_DATA_QUERY, {
    fetchPolicy: "no-cache",
  });
  const getReportData = async (
    reportName: string,
    reportVariables: Record<string, unknown>
  ) => {
    return await performQuery({
      variables: {
        reportName,
        reportVariables,
      },
      context: {
        reportId: Date.now(),
      },
    });
  };

  return { getReportData };
};
